import TheGrid from '@/views/dealers/operators/grid'
import Edit from '@/views/dealers/operators/edit'

export default {
  path: '/dealers/operators',
  redirect: '/dealers/operators/index',
  name: 'operators',
  meta: {
    auth: {
      redirect: {
        name: 'operators.index'
      },
      forbiddenRedirect: '/dashboard'
    },
    label: 'DSR'
  },
  component: {
    render(c) {
      return c('router-view')
    }
  },
  children: [{
    path: 'index',
    name: 'operators.index',
    component: TheGrid,
    meta: {
      auth: true,
      label: 'Lista'
    }
  }, {
    path: 'create',
    name: 'operators.create',
    component: Edit,
    meta: {
      auth: true,
      label: 'Criar'
    }
  }, {
    path: 'edit/:id',
    name: 'operators.edit',
    component: Edit,
    meta: {
      auth: true,
      label: 'Editar'
    }
  }]
}
